import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FirmwareUpdateStore } from '@store';
import {
  BundleUpdateProcessTypeEnum,
  BundleUpdateStatusEnum,
  VersionListParams,
} from '@vi-iot/client/index';
import { BannerType } from 'src/app/shared/components/banner/banner.model';

@Component({
  selector: 'app-firmware-update-version-list-banner',
  templateUrl: './firmware-update-version-list-banner.component.html',
  styleUrls: ['./firmware-update-version-list-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateVersionListBannerComponent {
  @Input() versionList: VersionListParams;

  protected readonly BundleUpdateStatus = BundleUpdateStatusEnum;
  protected readonly BundleUpdateProcessType = BundleUpdateProcessTypeEnum;
  protected readonly BannerType = BannerType;

  constructor(public firmwareUpdateStore: FirmwareUpdateStore) {}
}
